import { render, staticRenderFns } from "./pl-item.vue?vue&type=template&id=23b0785c&"
import script from "./pl-item.vue?vue&type=script&lang=js&"
export * from "./pl-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports